// Fachada do domínio Invites/Acesso — métodos da instância (ver core.ts).
import { inviteService } from './core';

export const lookupInvite        = inviteService.lookupInvite;
export const claimInvite         = inviteService.claimInvite;
export const acceptInvite        = inviteService.acceptInvite;
export const listPendingInvites  = inviteService.listPendingInvites;
export const listPendingProfiles = inviteService.listPendingProfiles;
export const createInvite        = inviteService.createInvite;
export const createReusableAexInvite = inviteService.createReusableAexInvite;
export const cancelInvite        = inviteService.cancelInvite;
export const approveUser         = inviteService.approveUser;
export const rejectUser          = inviteService.rejectUser;

export type { InviteLookup, PendingInvite, PendingProfile, AccessRpcResult, CreateInviteParams } from '@modules/invites';
